import { defaultValues, useUserContext } from '@src/entities/User/ui/context';
import { isEmpty, isUndefined } from 'lodash';

/**
 * Hook: useCurrentUser
 *
 * Retrieves the current user's information from the IDP.
 *
 * @returns {{emailAddress: string, msid: string, displayName: string, hasAccess: (boolean|null), hasPermission:
 *   defaultValues.hasPermission, roles: (string[]|*[]), hasRoles: (boolean|null), tenantId: string, currentRole:
 *   string, msalAccount: {}, localAccountId: string, homeAccountId: string}}
 */
export const useCurrentUser = () => {
  const userContext = useUserContext();

  if (isUndefined(userContext) || isEmpty(userContext)) {
    return defaultValues;
  }

  return userContext;
};
